<template>
  <div class="min-h-screen bg-gray-100 flex flex-col justify-center items-center py-12 px-4 sm:px-6 lg:px-8">
    <div class="max-w-md w-full text-center">
      <div class="text-6xl font-extrabold text-primary-600 mb-6">404</div>
      <h1 class="text-3xl font-bold text-gray-900 mb-2">页面未找到</h1>
      <p class="text-gray-600 mb-8">抱歉，您要查找的页面不存在或已被移除。</p>
      <router-link to="/" class="btn btn-primary">
        返回首页
      </router-link>
    </div>
  </div>
</template> 